import { CountryEntity } from 'api/types/entity';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';
import { useFormContext } from 'modules/client/common/forms/companyTaxResidencyForm';

import { FormContent } from './FormContent';

export interface CompanyTaxResidencySectionProps {
  title: string;
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const CompanyTaxResidencySection = ({
  title,
  countries,
  countriesLoading,
}: CompanyTaxResidencySectionProps) => {
  const { values, setFieldValue, readOnly } = useFormContext();

  const onAdd = () => {
    const companyTaxResidences = [
      ...values.companyTaxResidences,
      { country: null, taxNumber: '' },
    ];
    setFieldValue('companyTaxResidences', companyTaxResidences, false);
  };

  const onRemove = (index: number) => {
    const companyTaxResidences = [...values.companyTaxResidences];
    companyTaxResidences.splice(index, 1);
    setFieldValue('companyTaxResidences', companyTaxResidences, false);
  };

  return (
    <Section
      datax="companyTaxResidencySection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAdd}
          />
        )
      }
      title={title}
    >
      <FormContent
        countries={countries}
        countriesLoading={countriesLoading}
        onRemove={onRemove}
      />
    </Section>
  );
};
